import { apiFetch } from '../config/api'
import type { AggregateResult } from './weldParameterAggregator'
import type { CwCcwMode } from './weldUpload/types'

export interface UploadAlxSummaryInput {
  projectId: string
  pipeSetId: string
  weldId: string
  aggregate: AggregateResult
  passMappings: Record<string, string>
  sourceFilenames: string[]
  cwCcwMode: CwCcwMode
  uploadedAt: string
  replaceExisting?: boolean
}

export interface UploadAlxSummaryResult {
  weldParamsSectionKey: string
  uploadFormat: 'alx-summary'
  passCount: number
}

export async function uploadAlxSummary(
  input: UploadAlxSummaryInput
): Promise<UploadAlxSummaryResult> {
  const path = `/api/projects/${input.projectId}/pipe-sets/${input.pipeSetId}/welds/${input.weldId}/alx-summary/upload`
  return apiFetch<UploadAlxSummaryResult>(path, {
    method: 'POST',
    body: JSON.stringify({
      aggregate: input.aggregate,
      passMappings: input.passMappings,
      sourceFilenames: input.sourceFilenames,
      cwCcwMode: input.cwCcwMode,
      uploadedAt: input.uploadedAt,
      replaceExisting: input.replaceExisting ?? true
    })
  })
}
